import { render, staticRenderFns } from "./ConsumeTypeInfoCard.vue?vue&type=template&id=d2cea784&scoped=true&"
import script from "./ConsumeTypeInfoCard.vue?vue&type=script&lang=js&"
export * from "./ConsumeTypeInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2cea784",
  null
  
)

export default component.exports